import type {CaseReducer, PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'

type FeedbackFormInputType = {
  rating: number
  comment: string
  emailConsent: boolean
  email: string
}

type FeedbackFormVisibilityType = {visible: boolean}

type PipelinesFeedbackFormState = {
  visibility: FeedbackFormVisibilityType
  userInput: FeedbackFormInputType
  misc: {
    showCommentField: boolean
  }
}

const initialUserInput: FeedbackFormInputType = {
  rating: 0,
  comment: '',
  emailConsent: false,
  email: '',
}

const initialState: PipelinesFeedbackFormState = {
  visibility: {
    visible: false,
  },
  misc: {
    showCommentField: false,
  },
  userInput: initialUserInput,
}

const setEmailConsent: CaseReducer<PipelinesFeedbackFormState, PayloadAction<boolean>> = (
  state,
  action,
) => {
  state.userInput.emailConsent = action.payload
}

const setEmail: CaseReducer<PipelinesFeedbackFormState, PayloadAction<string>> = (
  state,
  action,
) => {
  state.userInput.email = action.payload
}

const setVisibility: CaseReducer<
  PipelinesFeedbackFormState,
  PayloadAction<FeedbackFormVisibilityType>
> = (state, action) => {
  state.visibility.visible = action.payload.visible
  if (!action.payload.visible) {
    state.userInput = initialUserInput
  }
}

const setRating: CaseReducer<PipelinesFeedbackFormState, PayloadAction<number>> = (
  state,
  action,
) => {
  state.userInput.rating = action.payload
}

const showCommentField: CaseReducer<PipelinesFeedbackFormState, PayloadAction<boolean>> = (
  state,
  action,
) => {
  state.misc.showCommentField = action.payload
}

const setComment: CaseReducer<PipelinesFeedbackFormState, PayloadAction<string>> = (
  state,
  action,
) => {
  state.userInput.comment = action.payload
}

export const feedbackForm = createSlice({
  name: 'feedbackForm',
  initialState,
  reducers: {
    setVisibility,
    setRating,
    setComment,
    showCommentField,
    setEmailConsent,
    setEmail,
  },
})
